import React, {Component} from 'react';
import PieChart from 'react-minimal-pie-chart';
import { Sparklines, SparklinesBars } from 'react-sparklines';
import { Scrollbars } from 'react-custom-scrollbars';
import ReactHighcharts from 'react-highcharts';

class AnswerSheetResults extends Component {

    constructor(props){
        super(props);

        this.state = {
            test: this.props.test,
            sections: this.props.test.sections,
            activeSection: 0
        }
    }
    renderConfigHighchart = () => {
        let data = [];
        this.props.test.sections[this.state.activeSection].questions.map((q, i) => {
            let item = {
                label: 'Q ' + (i + 1).toString(),
                y: q.time || 0,
                color: (q.userAnswer === q.correctOption) ? '#01a95c' : 'red'
            }
            data.push(item);
        })
        return (
            {
                chart: {
                    type: 'column',
                    backgroundColor: {
                        linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                        stops: [
                            [0, '#2d2d2d'],
                            [1, '#2d2d2d']
                        ]
                    }
                },
                title: false,
                yAxis: {
                    gridLineColor: '#3a3a3a',
                    title: {
                        text: 'Time Taken (seconds)',
                        style: {
                            color:"#fff"
                        }
                    },
                    labels: {
                        style: {
                            color:"#fff"
                        }
                    },
                    min: 0,
                },
                subtitle: false,
                xAxis: {
                    type: 'category',
                    gridLineColor: '#3a3a3a',
                    labels: {
                        rotation: -45,
                        style: {
                            fontSize: '10px',
                            fontFamily: 'Verdana, sans-serif',
                            color:"#fff",
                        }
                    }
                },
    
                legend: {
                    enabled: false
                },
                colors: ['#01a95c','#fcc'],
                tooltip: {
                    pointFormat: '<b>Question 3, 01:34, Wrong</b>'
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                    },
                    column: {
                        zones: [{
                            value: 20, // Values up to 10 (not including) ...
                            color: 'red' // ... have the color blue.
                        },{
                            color: '#01a95c' // Values from 10 (including) and up have the color red
                        }]
                    }
                },
                series: [{
                    name: 'Questions',
                    data: data,
                    dataLabels: {
                        enabled: false,
                        rotation: -90,
                        color: '#fff',
                        align: 'right',
                        format: '1{point.y:.1f}', // one decimal
                        y: 10, // 10 pixels down from the top
                        style: {
                            fontSize: '12px',
                            fontFamily: 'Verdana, sans-serif',
                            textOutline: 0
                        }
                    }
                }]
            }
        )
    }

    renderQuestions = () => {
        return this.props.test.questions.map(question => {
            return (
                <div className={"question-container"}>
                    <h4>
                        {(question.userAnswer == question.correctOption) ?
                            <span className={"zmdi zmdi-check text-success"}></span>
                            :
                            <span className={"zmdi zmdi-close text-danger"}></span>
                        }
                        &nbsp;
                        {question.question}</h4>

                    <div className={(question.userAnswer == "A" && question.correctOption == "A" || question.correctOption == "A") ? "answer text-success" :
                        (question.userAnswer == "A" && question.correctOption != "A") ? "answer text-danger" : "answer"}>
                        <b>A:</b> {question.optionA}

                    </div>
                    <div className={(question.userAnswer == "B" && question.correctOption == "B" || question.correctOption == "B") ? "answer text-success" :
                        (question.userAnswer == "B" && question.correctOption != "B") ? "answer text-danger" : "answer"}>
                        <b>B:</b> {question.optionB}

                    </div>
                    <div className={(question.userAnswer == "C" && question.correctOption == "C" || question.correctOption == "C") ? "answer text-success" :
                        (question.userAnswer == "C" && question.correctOption != "C") ? "answer text-danger" : "answer"}>
                        <b>C:</b> {question.optionC}

                    </div>
                    <div className={(question.userAnswer == "D" && question.correctOption == "D" || question.correctOption == "D") ? "answer text-success" :
                        (question.userAnswer == "D" && question.correctOption != "D") ? "answer text-danger" : "answer"}>
                        <b>D:</b> {question.optionD}

                    </div>
                </div>
            )
        })
    }

    renderSingleQuestion(question, index){
        let userAnswer = question.userAnswer;
        let correct = question.correctOption;
        return (
            <div className="table-question-row">
                <ul className="inline-block">
                    <li className="question-number">{index + 1}</li>
                    <li className={(correct == userAnswer && correct == "A") ?
                        "QuestionAble CorrectQuestion" :
                        (correct != userAnswer && userAnswer == "A") ?
                            "QuestionAble InCorrectAnswer" :
                            (correct != userAnswer && correct == "A") ?
                                "QuestionAble " : "QuestionAble"}>

                        <input type="radio" id={"question-" + index + "A"} name={"question-" + index} value="A"

                        />
                        <label for={"question-" + index + "A"}>A</label>
                        <div className="selected"></div>
                    </li>
                    <li className={(correct == userAnswer && correct == "B") ? 
                        "QuestionAble CorrectQuestion" : 
                        (correct != userAnswer && userAnswer == "B") ? 
                            "QuestionAble InCorrectAnswer" :
                            (correct != userAnswer && correct == "B") ?
                                "QuestionAble " : "QuestionAble"}>

                    <input type="radio" id={"question-" + index + "B"} name={"question-" + index} value="B"

                        />
                        <label for={"question-" + index + "B"}>B</label>
                        <div className="selected"></div>
                    </li>
                    <li className={(correct == userAnswer && correct == "C") ?
                        "QuestionAble CorrectQuestion" :
                        (correct != userAnswer && userAnswer == "C") ?
                            "QuestionAble InCorrectAnswer" :
                            (correct != userAnswer && correct == "C") ?
                                "QuestionAble " : "QuestionAble"}>
                    <input type="radio" id={"question-" + index + "C"} name={"question-" + index} value="C"

                        />
                        <label for={"question-" + index + "C"}>C</label>
                        <div className="selected"></div>
                    </li>
                    <li className={(correct == userAnswer && correct == "D") ?
                        "QuestionAble CorrectQuestion" :
                        (correct != userAnswer && userAnswer == "D") ?
                            "QuestionAble InCorrectAnswer" :
                            (correct != userAnswer && correct == "D") ?
                                "QuestionAble " : "QuestionAble"}>
                    <input type="radio" id={"question-" + index + "D"} name={"question-" + index} value="D"

                        />
                        <label for={"question-" + index + "D"}>D</label>
                        <div className="selected"></div>
                    </li>
                    <li className={(correct == userAnswer && correct == "E") ?
                        "QuestionAble CorrectQuestion" :
                        (correct != userAnswer && userAnswer == "E") ?
                            "QuestionAble InCorrectAnswer" :
                            (correct != userAnswer && correct == "E") ?
                                "QuestionAble " : "QuestionAble"}>
                    <input type="radio" id={"question-" + index + "E"} name={"question-" + index} value="E"

                        />
                        <label for={"question-" + index + "E"}>E</label>
                        <div className="selected"></div>
                    </li>
                    <li className={(correct == userAnswer && correct == "E") ? "QuestionAble CorrectQuestion" : (correct != userAnswer && userAnswer == "E") ? "QuestionAble InCorrectAnswer" : "QuestionAble" }>

                    <input type="checkbox" id="Option<?php echo $x ?>Q" name="QuestionHELP<?php echo $x ?>" value="HELP"/>
                        <label for="Option<?php echo $x ?>Q">?</label>
                        <div className="selected"></div>
                    </li>

                </ul>
                <div className="question-details">
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A debitis dolor est inventore maiores nihil quae quasi quo rerum vero! Alias dicta enim error, fugiat harum in ipsa provident ut?</p>
                </div>
            </div>
        )
    }

    renderResults = () => {

        let guesses = 0;

        this.props.test.sections.map(s => {
            guesses += s.questions.filter(q => !q.userAnswer).length
        })
        return (
            <div>

                <div className="b-b wrapper-md">
                    <div className="row">
                        <div className="col-sm-8">
                            <h1 className="m-n font-thin h3 text-black">{this.props.test.title}</h1>
                            <small className="text-muted">{this.props.test.instructions}</small>

                        </div>
                        <div className="col-sm-4 text-right">


                         </div>
                    </div>
                </div>

                <div className="content no-padding bg-white">
                    <div className="sp-20 score_summary_result b-b">
                        <div className="row">
                            <div className="col-sm-3">
                                <div className="">
                                    <p>Your Score</p>
                                    <h3>{this.props.test.correctAnswers} / {this.props.test.totalQuestions}</h3>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="">
                                    <p>Correct Answers</p>
                                    <h3>{this.props.test.correctAnswers}</h3>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="">
                                    <p>Incorrect Answers</p>
                                    <h3>{this.props.test.totalQuestions - this.props.test.correctAnswers}</h3>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="">
                                    <p>Guess Work</p>
                                    <h3>{guesses}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.test.correctPercent < 80 && !this.props.onboarding &&
                        <div className="retake-subject text-red">
                            Unfortunately, you didn't pass this test.  We're setting things up so you can take this subject again.  When you're ready, hit the continue button to get started.
                        </div>
                    }
                    <form method="post" className="sp-20 results-score" id="finalScoreForm">
                        <div className="row">
                            <div className="table-question sm-bottom0">
                            {this.props.test.sections.map((section, index) => {
                                return (
                                    <div>
                                        <div className={"pull-right"}>
                                            <div className="video-question-summary">
                                                <PieChart
                                                    style={{width: 50, margin: '0 auto'}}
                                                    data={[
                                                        {value: section.correctPercent, color: '#555'},
                                                        {value: section.correctAnswers, color: '#e33339'}
                                                    ]}
                                                    totalValue={section.questions.length}
                                                    lineWidth={10}
                                                    rounded={true}
                                                />
                                                <p className="diagnostic-pie-chart-counter">{section.correctPercent}%</p>
                                            </div>
                                        </div>
                                        <div>
                                        <h4 className={"text-left"}>Section {index + 1} {section.name ? "- " + section.name : ''}</h4>
                                        <p className={"text-left"}>
                                           <div>
                                               <b>Correct Answers:</b> {section.correctAnswers}/{section.questions.length}
                                           </div>
                                            <div>
                                                <b>Incorrect Answers:</b> {section.incorrectAnswers}/{section.questions.length}
                                            </div>

                                        </p>
                                        </div>
                                        <div>
                                            {section.questions.map((q, i) => {
                                                return this.renderSingleQuestion(q, i)
                                            })}
                                        </div>
                                        <br /><br />
                                    </div>
                                )
                            })}
                            </div>
                        </div>
                    </form>
                    </div>
                    </div>
        )
    }

    render(){
        
        return (
            <div className="modal fade in show" id="FinalScoreModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body no-padding" style={{background: "#4487ec", color: "#fff"}}>
                        <Scrollbars style={{ height: "calc(100vh - 200px)" }}>
                            <div className="nav-tabs-custom no-bg">
                                <ul className="nav nav-tabs no-bg">
                                    {this.props.test.sections.map((section, i) => {
                                        return (
                                            <li className={this.state.activeSection == i ? 'active' : ''}>
                                                <a href="#" onClick={(e) => {
                                                    e.preventDefault();
                                                    this.setState({activeSection: i});
                                                }} data-toggle="tab">Section {i + 1}</a>
                                            </li>
                                        )
                                    })}
                                </ul>
                                <div className="tab-content no-bg no-padding">
                                    {this.props.test.sections.map((section, i) => {
                                        let questions = section.questions;

                                        return (
                                            <div className={`tab-pane no-bg ${this.state.activeSection == i ? 'active' : ''}`}
                                                 id={`FinalScoreTab-${i}`}>

                                                <div className="sp-10">
                                                    <div className="sm-bottom20">
                                                        <h1 className="font-300 sm-top0 font-20">Total Score</h1>
                                                        <div className="font-60 font-300"><span className="counter" data-from="0" data-to="39"></span></div>
                                                    </div>
                                                    {!this.props.test.diagnostictestId &&
                                                    <div>
                                                        <p className="border-bottom sp-bottom10 sm-bottom20">Time Per
                                                            Question</p>
                                                            <ReactHighcharts
                                                                config={this.renderConfigHighchart()}
                                                                isPureConfig={true}
                                                                neverReflow={true}
                                                                ref="chart"
                                                            />
                                                    </div>
                                                    }
                                                </div>
                                                <div>
                                                <div class="table-question sm-bottom0">
                                                    {questions.map((question, qi) => {
                                                        return this.renderSingleQuestion(question, qi)
                                                    })}                                                
                                                </div>
                                            </div>

                                            </div>
                                        )
                                    })}


                                </div>
                            </div>
                            </Scrollbars>
                            
                        </div>
                        <div className={"modal-footer"}>
                            {!this.props.test.practice && this.props.test.correctPercent < 80 && !this.props.test.diagnostictestId &&
                                <p className="light-text text-red">Unfortunately, you did not pass this test.  We've set things up for you to take the subject again.  When you're ready, click continue.</p>
                            }

                            {this.props.test.practice && !this.props.test.diagnostictestId &&
                                !this.props.test.passed ?
                                    this.props.test.failBehavior === 'lecture' ?
                                        <p className="light-text">You failed this test.  When you're ready to give it another go, click Continue.</p>
                                    : <p className="light-text">You failed this test.  This means you'll have to start this subject again.  When you're ready to give it another go, click Continue.</p>
                                :
                                !this.props.test.passed ?
                                    this.props.test.failBehavior === 'lecture' ?
                                        <p className="light-text">You failed this test.  When you're ready to give it another go, click Continue.</p>
                                    : <p className="light-text">You failed this test.  This means you'll have to start this subject again.  When you're ready to give it another go, click Continue.</p>
                                :
                                <p className="light-text">You've completed the test.  You can now continue with your course.</p>
                            }
                            <button className="btn btn-danger" onClick={(e) => this.props.continue(e)}>Continue <i className="zmdi zmdi-arrow-forward"></i> </button>
                        </div>
                    </div>
                </div>
            </div>
        )
                
        return (
            <div
                className={`bootbox modal fade bootbox-confirm in`}
                tabIndex="-1"
                role="dialog"
                style={{
                    display: "block",
                    paddingRight: 15
                }}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-body">
                            <button
                                type="button"
                                className="bootbox-close-button close"
                                data-dismiss="modal"
                                aria-hidden="true"
                                style={{marginTop: -10}}
                                onClick={() => this.props.hideModal()}
                            >
                                ×
                            </button>
                            <div className="bootbox-body">
                                <div className="sp-10 font-16">
                                    {this.renderResults()}
                                </div>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button className="btn btn-base btn-lg" onClick={(e) => this.props.continue(e)}>Continue <i className="zmdi zmdi-arrow-forward"></i> </button>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default AnswerSheetResults;


// WEBPACK FOOTER //
// ./src/components/UserCourse/AnswerSheetResults.js